"use client"

import { useWindowEvent } from "src/components/hooks/useWindowEvent"
import { generateTrackingEventId } from "src/tracking/events"
import {
  googleTrackFormClose,
  googleTrackFormStepSubmit,
  googleTrackFormSubmit,
  googleTrackFormUrlRedirect,
  googleTrackFormView,
} from "../google/api"
import { klaviyoDebug } from "./events"

export const KlaviyoGoogleAnalyticsBridge = () => {
  useWindowEvent("klaviyoForms", (event_) => {
    // https://developers.klaviyo.com/en/v1-2/docs/track-klaviyo-form-activity-using-javascript
    // https://help.klaviyo.com/hc/en-us/articles/115005077027#h_01HF9XMN14454KERRMXMFA4E5P
    // Note that this implementation intentionally differs from the example in
    // the Klaviyo documentation.
    const event = event_ as CustomEvent

    klaviyoDebug(event.detail)

    const form_id = "klaviyo_" + event.detail?.formId
    const step_name = event.detail?.metaData?.$step_name
    const event_id = generateTrackingEventId()

    if (event.detail.type === "open" || event.detail.type === "embedOpen") {
      googleTrackFormView({ event_id, form_id, step_name })
    }
    if (event.detail.type === "submit") {
      googleTrackFormSubmit({ event_id, form_id })
    } else if (event.detail.type === "stepSubmit" && step_name) {
      googleTrackFormStepSubmit({ event_id, form_id, step_name })
    } else if (event.detail.type === "redirectedToUrl") {
      googleTrackFormUrlRedirect({ event_id, form_id })
    } else if (event.detail.type === "close" /* dialog */) {
      googleTrackFormClose({ event_id, form_id })
    } else {
      // ignore
    }
  })

  return null
}
